import React from "react";
import { MEDIA } from "../mock";
import Reveal from "./Reveal";

const MediaSection = () => (
  <section className="py-14 bg-white border-y border-gray-100 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center mb-9">
        <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">What the Media Says</span>
        <h2 className="text-2xl sm:text-3xl font-bold text-navy font-head mt-2">Featured in the News</h2>
      </Reveal>
    </div>
    <div className="marquee-wrap relative">
      <div className="marquee-track gap-4 px-2">
        {[...MEDIA, ...MEDIA].map((m, i) => (
          <div key={i} className="shrink-0 bg-[#f7f9fc] border border-gray-100 rounded-xl px-8 py-5 flex items-center justify-center min-w-[180px]">
            <span className="font-head font-bold text-navy/70 text-lg whitespace-nowrap">{m}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MediaSection;
